import { INVOICE_STATUS_LABELS } from './supplierLedgerConstants';

export const statusColor = {
  draft: 'default',
  open: 'warning',
  partially_paid: 'info',
  paid: 'success',
  cancelled: 'error',
  payment_order_generated: 'info',
};

export const INVOICE_DISPLAY_STATUS_LABELS = {
  ...INVOICE_STATUS_LABELS,
  payment_order_generated: 'Orden generada',
};

export const DEFAULT_ROWS_PER_PAGE = 10;

export const VAT_RATE_OPTIONS = [
  { value: '0', label: '0%' },
  { value: '10.5', label: '10,5%' },
  { value: '21', label: '21%' },
];

export const RECEIPT_TYPE_OPTIONS = [
  { value: 'A', label: 'Factura A' },
  { value: 'B', label: 'Factura B' },
  { value: 'C', label: 'Factura C' },
  { value: 'M', label: 'Factura M' },
  { value: 'E', label: 'Factura E' },
  { value: 'NCA', label: 'Nota de crédito A' },
  { value: 'NCB', label: 'Nota de crédito B' },
  { value: 'NCC', label: 'Nota de crédito C' },
  { value: 'NDA', label: 'Nota de débito A' },
  { value: 'NDB', label: 'Nota de débito B' },
  { value: 'NDC', label: 'Nota de débito C' },
  { value: 'REC', label: 'Recibo' },
];

export const ADJUSTMENT_TYPE_OPTIONS = [
  { value: 'opening_balance', label: 'Saldo inicial' },
  { value: 'advance_payment', label: 'Anticipo / pago a cuenta' },
  { value: 'debit_adjustment', label: 'Ajuste débito' },
  { value: 'credit_adjustment', label: 'Ajuste crédito' },
];

export const ADJUSTMENT_STATUS_LABELS = {
  active: 'Activo',
  cancelled: 'Anulado',
};

export const RETENTION_TYPE_OPTIONS = [
  { value: 'income_tax', label: 'Ganancias' },
  { value: 'gross_income', label: 'IIBB' },
  { value: 'other', label: 'Otras' },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'transfer', label: 'Transferencia' },
  { value: 'cash', label: 'Caja' },
  { value: 'own_check', label: 'Cheque propio' },
  { value: 'third_party_check', label: 'Cheque de terceros' },
];

export const CHECK_KIND_OPTIONS = [
  { value: 'own', label: 'Propio' },
  { value: 'third_party', label: 'Terceros/canje' },
];

export const invoiceSections = [
  { id: 'provider', label: 'Proveedor y comprobante' },
  { id: 'amounts', label: 'Importes' },
  { id: 'control', label: 'Control y adjunto' },
  { id: 'preview', label: 'Detalle' },
];

export const paymentOrderBaseSections = [
  { id: 'summary', label: 'Resumen' },
  { id: 'data', label: 'Datos' },
  { id: 'invoices', label: 'Facturas incluidas' },
  { id: 'payment', label: 'Medios de pago' },
  { id: 'preview', label: 'Previsualización' },
];

export const paymentOrderBatchSection = { id: 'batch', label: 'Lote por proveedor' };

export const compactFormSx = {
  px: 2.5,
  py: 2,
  gap: 1.5,
  alignItems: 'center',
  flexWrap: 'wrap',
  overflowX: 'visible',
};

export const tabPanelSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
};

export const DASHBOARD_CHART_COLORS = [
  '#5e894f',
  '#ef6c00',
  '#0288d1',
  '#d44242',
  '#7b1fa2',
  '#00897b',
  '#f9a825',
  '#3949ab',
  '#c2185b',
  '#455a64',
];

export const getDashboardChartColor = (index) =>
  DASHBOARD_CHART_COLORS[index % DASHBOARD_CHART_COLORS.length];
